import { useCallback, useMemo, useState } from 'react';

import type { Employee } from '@pages/Calendar/data';
import type { EventDragState } from '@pages/Calendar/ui/AppointmentCard/hooks';

interface UseDaysViewportProps {
  dayColumns: Employee[];
}

export const useDaysViewport = ({ dayColumns }: UseDaysViewportProps) => {
  const [dragState, setDragState] = useState<EventDragState | null>(null);

  const dragStateChangeHandler = useCallback((state: EventDragState | null) => {
    setDragState(state);
  }, []);

  const isDragPreviewVisible = useMemo(
    () =>
      dragState !== null &&
      dragState.targetEmployeeId !== dragState.sourceEmployeeId,
    [dragState]
  );

  return {
    dragState,
    dayColumns,
    isDragPreviewVisible,
    dragStateChangeHandler,
  };
};
